import React, { useState } from "react";
import { CiCircleCheck } from "react-icons/ci";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { PiWarningCircleLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import "./sign.scss";

const ChangePassword = ({ data }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    repassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validate = () => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(formData.password);
    const hasLowerCase = /[a-z]/.test(formData.password);
    const hasNumbers = /\d/.test(formData.password);

    if (formData.password.length < minLength) {
      setErrorMsg(data.passwordLength);
      return false;
    }
    if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
      setErrorMsg(data.passwordRequirement);
      return false;
    }

    if (formData.password !== formData.repassword) {
      setErrorMsg(data.passwordNotMatch);
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    serverInstance
      .post(
        "/school/change-password",
        {
          password: formData.password,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setErrorMsg("");
        setSuccessMsg("Нууц үг амжилттай солигдлоо.");
      })
      .catch((error) => {
        console.error("Change password error:", error);
        setErrorMsg(
          error?.response?.data?.message || "Хүсэлт илгээхэд алдаа гарлаа"
        );
        setLoading(false);
      });
  };

  return (
    <div className="sign-container-card2">
      <h2>{data.changePassword}</h2>
      {loading ? <Dimmer /> : null}
      <form className="sign-form" onSubmit={handleSubmit}>
        <div className="form-div">
          <label className="sign-label">{data.password}</label>
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="sign-input"
            />
            {showPassword ? (
              <FaRegEye
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle"
              />
            ) : (
              <FaRegEyeSlash
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle"
              />
            )}
          </div>
        </div>
        <div className="form-div">
          <label className="sign-label">{data.repassword}</label>
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              name="repassword"
              value={formData.repassword}
              onChange={handleChange}
              required
              className="sign-input"
            />
          </div>
        </div>
        {errorMsg ? (
          <div className="form-div error-msg">
            <PiWarningCircleLight />
            &nbsp;{errorMsg}
          </div>
        ) : null}
        {successMsg ? (
          <div className="form-div success-msg">
            <CiCircleCheck />
            &nbsp;{successMsg}
          </div>
        ) : null}
        <div className="form-div">
          <br />
          <button type="submit" className="sign-button" disabled={loading}>
            {data.changePassword}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
